import { render, staticRenderFns } from "./LoginSelectionPage.vue?vue&type=template&id=4a9883c5&"
import script from "./LoginSelectionPage.vue?vue&type=script&lang=ts&"
export * from "./LoginSelectionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9883c5')) {
      api.createRecord('4a9883c5', component.options)
    } else {
      api.reload('4a9883c5', component.options)
    }
    module.hot.accept("./LoginSelectionPage.vue?vue&type=template&id=4a9883c5&", function () {
      api.rerender('4a9883c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/LoginSelectionPage.vue"
export default component.exports